import React, {Component} from "react";
import SimpleReactValidator from "simple-react-validator";

/* Import Components */
import Input from "./Input";
import TextArea from "./TextArea";
import Select from "./Select";
import Button from "./Button";
import EmailInput from "./EmailInput";
import TelephoneInput from "./TelephoneInput";
import Confirmation from "./Confirmation";
import ResearchDisclaimer from "./ResearchDisclaimer";
import CheckBox from "./CheckBox";

import FetchHelper from "./helpers/FetchHelper";
import RadioButton from "./RadioButton";

class FormContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initialState: true,
            loading: false,
            submitted: false,
            newUser: {},
            localAuthorityOptions: props.localAuthorityOptions || [],
            parentCarerOptions: props.parentCarerOptions || [],
        };

        const validateNumber = (phone_number) => {
            if (!phone_number || phone_number?.length === 0) {
                return {
                    valid: true,
                    message: "phone number not required"
                }
            } else {
                if (phone_number?.startsWith('07') || phone_number?.startsWith('+44')) {
                    let numberLength = phone_number.length || 0
                    if (phone_number?.startsWith('0')) {
                        if (numberLength !== 11) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (0) must be 11 characters, currently ${numberLength} chars.`
                            }
                        }
                    }
                    if (phone_number?.startsWith('+44')) {
                        if (numberLength !== 13) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (+44) must be 13 characters, currently ${numberLength} chars`
                            }
                        }
                    }
                    if (!phone_number?.match(/^[+0-9]*$/)) {
                        return {
                            valid: false,
                            message: "A phone number can only have numbers or +"
                        }
                    }
                } else {
                    return {
                        valid: false,
                        message: `UK phone number must start with either (+44) or (07)`
                    }
                }
            }
            return {
                valid: true,
            }
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: "en",
            className: "text-danger",
            validators: {
                custom_phone_number: {
                    message: ':replaced',
                    rule: (val, params, validator) => {
                        return validateNumber(val).valid
                    },
                    messageReplace: (message, params) => {
                        return validateNumber(params[0]).message
                    },  // optional
                }
            }
        });
    }

    renderErrorPage = () => {
        window.location.assign("/500.html");
    };

    handleInputChange = e => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: value
            }
        }));
    };

    handleCheckBox = e => {
        const {name, value} = e.target;
        const {newUser} = this.state;
        let values = newUser[name] || [];
        if (values.indexOf(value) > -1) {
            values = values.filter(s => s !== value);
        } else {
            values.push(value);
        }

        this.setState(prevState => ({
            newUser: {...prevState.newUser, [name]: values}
        }));
    };

    handleFormSubmit = e => {
        e.preventDefault();

        const {csrfToken, parentDomain} = this.props;
        let userData = this.state.newUser;

        this.setState({initialState: false});

        FetchHelper.fetchWithPost({
            context: this,
            csrfToken,
            parentDomain,
            type: "exchange_parent",
            body: userData
        });
    };

    renderSubmitButton = () => {
        const {initialState, loading} = this.state;
        const valid = initialState || this.validator.allValid();
        return (
            <>
                {!valid && (
                    <div className="alert alert-danger">
                        There are unresolved form errors, please correct the form before
                        resubmitting.
                    </div>
                )}
                <Button
                    type="submit"
                    className="btn-primary"
                    disabled={!valid || loading}
                >
                    Submit
                </Button>
            </>
        );
    };

    render() {
        const {
            dateOfBirth,
            firstName,
            lastName,
            emailAddress,
            phoneNumber,
            localAuthorityId,
            referrerInformation,
            parentCarer,
            exchangeParentConfirmation,
        } = this.state.newUser;

        const {
            submitted,
            localAuthorityOptions,
            parentCarerOptions,
        } = this.state;

        return (
            <div className="container">
                <h1>
                    The-Exchange Parent
                    <small>Referrals for counselling and psychological support</small>
                </h1>
                <div className="row justify-content-start">
                    {submitted ? (
                        <Confirmation
                            referralType="Exchange Parent"
                            returnCallback={() => {
                                this.setState({
                                    submitted: false,
                                    newUser: {},
                                    initialState: true
                                });
                            }}
                        />
                    ) : (
                        <form className="col-8" onSubmit={this.handleFormSubmit} noValidate>
                            <div className="alert alert-secondary">
                                <p>
                                    Fields marked with <span className="required-field">*</span>{" "}
                                    are mandatory.
                                </p>
                            </div>
                            <div className="form-group">
                                <Input
                                    inputtype={"text"}
                                    label="Parent first name"
                                    name="firstName"
                                    value={firstName}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "parent first name",
                                    firstName,
                                    "required|alpha_space"
                                )}
                            </div>
                            <div className="form-group">
                                <Input
                                    inputtype={"text"}
                                    label="Parent surname"
                                    name="lastName"
                                    value={lastName}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "parent surname",
                                    lastName,
                                    "required|alpha_space"
                                )}
                            </div>
                            <div className="form-group">
                                <EmailInput
                                    label={"Parent email address"}
                                    name="emailAddress"
                                    id="emailAddress"
                                    value={emailAddress}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message("parent email address", emailAddress, "required|email")}
                            </div>

                            <div className="form-group">
                                <Input
                                    name="dateOfBirth"
                                    label="Parent date of birth (DD/MM/YYYY)"
                                    value={dateOfBirth}
                                    required={true}
                                    type="date"
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "parent date of birth",
                                    dateOfBirth,
                                    "required"
                                )}
                            </div>
                            <div className="form-group">
                                <TelephoneInput
                                    name="phoneNumber"
                                    label={"Parent phone number"}
                                    value={phoneNumber}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "parent phone number",
                                    phoneNumber,
                                    `required|custom_phone_number:${phoneNumber}`,
                                )}
                            </div>
                            <div className="form-group">
                                <Select
                                    label="Local authority"
                                    name="localAuthorityId"
                                    options={localAuthorityOptions}
                                    value={localAuthorityId}
                                    placeholder={"Please Select"}
                                    handleChange={this.handleInputChange}
                                    required
                                />{" "}
                                {this.validator.message(
                                    "local authority",
                                    localAuthorityId,
                                    "required"
                                )}
                            </div>
                            <div className="form-group">
                                <TextArea
                                    name="referrerInformation"
                                    label="Referrer name and contact details"
                                    value={referrerInformation}
                                    required={true}
                                    maxLength={2000}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message(
                                    "referrer name and contact details",
                                    referrerInformation,
                                    "required"
                                )}
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label="Are you a parent carer?"
                                    name="parentCarer"
                                    options={parentCarerOptions}
                                    value={parentCarer}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">                            
                                <CheckBox
                                    label="
                    This statement is for those who are accessing our services for themselves
                    or on behalf of another person (i.e. making a referral) If you are accessing
                    the services for yourself, please read this statement because it sets out what
                    you are consenting to. If you are referring someone to receive confidential support
                    please read and confirm. To process this referral and put in place psychological wellbeing
                    support, the organisation requires the information which is to be entered into the referral form.
                    This is personal information covered under the GDPR regulations and therefore it is a requirement
                    that the person who is being referred has consented to the personal information being shared with this
                    organisation. The data is confidential and not shared with others, but we retain the right to use this
                    information to contact others if we believe the person receiving our support (or others) is in danger or
                    at risk of abuse. As far as possible we will seek consent before taking this action, but the safety of
                    those we support is our priority.
                "
                                    helpText="If the support is for you then it is necessary to confirm that you
                    understand this statement. If the referral is being made on behalf of another, then the person making
                    the referral must confirm that the consent of the person has been sought and received."
                                    name="exchangeParentConfirmation"
                                    options={["I agree"]}
                                    selectedOptions={exchangeParentConfirmation}
                                    onChange={this.handleCheckBox}
                                    required={true}
                                />
                                {this.validator.message(
                                    "agreement",
                                    exchangeParentConfirmation,
                                    "required"
                                )}
                            </div>
                            {this.renderSubmitButton()}
                        </form>
                    )}
                    <ResearchDisclaimer />
                </div>
            </div>
        );
    }
}

export default FormContainer;